import { Typography } from 'antd';
import { useIntl } from 'react-intl';
import classes from '../Card.module.css';
import { Snowflake } from 'shared/ui/icons';

export const FrozenOverlay = () => {
  const { formatMessage: t } = useIntl();
  return (
    <div className={classes['status-overlay']}>
      <Snowflake />
      <Typography.Text className={classes['text']}>
        {t({ id: 'card.universal.status.frozen' })}
      </Typography.Text>
    </div>
  );
};
